import {DEFAULT_API_URL} from "../data/constants";

export function getBaseUrl() {
  if (process && process.env && process.env.REACT_APP_API_BASEURL) {
    return process.env.REACT_APP_API_BASEURL;
  }

  return DEFAULT_API_URL;
}